import { combineReducers } from 'redux'
import user from './userReducers' // Utilisateur en cours
// import cfg from './cfgReducers' // Configuration interface

export default combineReducers({
  user,
  //   cfg
})
